import React, { Component } from 'react'
import { withRouter, Route } from "react-router-dom";

import Autosuggest from 'react-autosuggest';

function escapeRegexCharacters(str) {
    return encodeURI(str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
}

function getSuggestionValue(suggestion) {
    return suggestion;
}

function renderSuggestion(suggestion) {
    return (
        <span>{suggestion}</span>
    );
}

export class SearchBox extends Component {
    constructor() {
        super();

        this.state = {
            value: '',
            suggestions: []
        };
    }
    onChange = (event, { newValue, method }) => {
        this.setState({
            value: newValue
        });
    };

    onSuggestionSelected = (event, { suggestion, method }) => {
     //   console.log(suggestion, method)
    }

    onSuggestionsFetchRequested = ({ value }) => {
        console.log(value)
        fetch('/api/template/FindSearchKeywords?filter=' + escapeRegexCharacters(value), {
            method: 'GET'
        }).then(Response => Response.json()).then(
            json => {
                // console.log(items)
               // console.log(json)

                this.setState({
                    suggestions: json
                });
            }
        )
            .catch(error => {
                console.error(error);
                this.setState({
                    suggestions: []
                });
            })
    };

    onKeyDown = (e) => {

       // console.log(encodeURI(e.target.value))
        if (e.target.value.replace(/^\s+|\s+$/g, "") != ""&&e.keyCode === 13)
            this.props.history.push("/Search?key=" + encodeURI(e.target.value))
    }

    onClick = () => {
        if (this.state.value.replace(/^\s+|\s+$/g, "")!="")
        this.props.history.push("/Search?key=" + encodeURI(this.state.value))
    }

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    render() {
        const { value, suggestions } = this.state;
        const inputProps = {
            placeholder: "输入关键字查询",
            value,
            onChange: this.onChange,
            onKeyDown: this.onKeyDown
        };

        return (
            <div className="search center">
                <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    onSuggestionSelected={this.onSuggestionSelected}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    inputProps={inputProps} />
                <span className="d-block" onClick={this.onClick}></span>
            </div>

        )
    }
}

export default withRouter(SearchBox)